module.exports = __webpack_public_path__ + "img/Unlock Test.76d9dfea.svg";